<section class="main-section report-section">
  @if(report==null && isInitialised){
 

  <app-my-insights [packageInformation]="this.packageInformation" [selectedToolkit]="this.report_context??this.report"></app-my-insights>
  }
  @else if(isInitialised){
    <header class="d-block d-xl-none justify-content-between align-items-center main-heading report-heading">
      <div class="d-flex align-items-center">
        <a class="btn btn-link me-3 p-0 d-block d-xl-none back-canvas" data-bs-toggle="offcanvas" href="#offcanvasExample"
          role="button" aria-controls="offcanvasExample">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 7H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            <path d="M3 12H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
            <path d="M3 17H21" stroke="#292D32" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </a>
      </div>
    </header>

    
  <div id="reportWrapper" style="position: relative; height: 100vh;">
    <div id="overlay" [style.display]="isLoading?'flex':'none'">
      <div id="deeshaSpinnerArea" >
        <img id="deeshaSpinner" src="assets/images/deesha-loader.png" alt="Loading..." />
        <div></div>
        <mat-progress-bar *ngIf="isLoading" id="deeshaSpinnerProgress"   mode="indeterminate" color="accent" class="progress-bar"></mat-progress-bar>
      </div>
    </div>

      <div id="reportContainer" [style.visibility]="isLoading?'hidden':'visible'"></div>

  </div>

  <div *ngIf="report==null && isLoading==false" class="noDataFound theme-card-text">
    <h1>No Analytics Toolkit Found</h1>
  </div>
  }
 
</section>
